module.exports = {"new":{"header":"Welcome to {{ partnerName }}","header_static":"Welcome","sub_header":"Account successfully created"},"close":"close","brand_karamba":{"brand_name":"Karamba.com"},"variant_hopa":{"brand_name":"Hopa.com"},"variant_mr-play":{"brand_name":"MrPlay.com"},"variant_tradacasino":{"brand_name":"Tradacasino.com"},"variant_betiton":{"brand_name":"Betiton.com"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/welcome.json
// module id = 659
// module chunks = 247 1422